<div class="UNFAPP-lvmtrcls-bx UNFAPP-hbox">
  <div class="UNFAPP-lvmtrcls-imgbx class-background-{{classData?.subject.toLowerCase()}}">
      <span class="UNFAPP-live-tag" *ngIf="dataType != 'past' && isLive">
        <img src="assets/img/reddot-live.gif" class="UNFAPP-live-icn" />
        Live
      </span>
      <span class="UNFAPP-today-tag" *ngIf="dataType != 'past' && isToday && !isLive">
        Today
      </span>
      <span class="UNFAPP-tomorrow-tag" *ngIf="dataType != 'past' && isTomorrow">
        Tomorrow
      </span>
      <span class="UNFAPP-star-reward" *ngIf="dataType == 'past' && classData?.feedbackValue">
        <i class="fa fa-star UNFAPP-star-icn" aria-hidden="true"></i> {{classData?.feedbackValue}}
      </span>

      <img [src]="classData?.teacher?.profileImage" class="lvmtrcls-imgbx-img" alt="" (error)="_helper.profileImgError($event)" />
  </div>
  <div class="UNFAPP-lvmtrcls-cntarea justify-content-between">
    <div class="UNFAPP-lvmtrcls-onlycntrow">
      <div class="UNFAPP-mstr-subjct">
        <!-- ? Showing what subject is coming from CMS -->
        <ng-container >
          <img src="assets/img/subject-icons/{{classData?.subject | lowercase }}-icon.svg" class="mstr-subjct-icon" alt="" />
          <span>{{classData?.subject}}</span>
      </ng-container>
      <!-- <ng-container *ngIf="showScience && classData?.subject?.toLowerCase() != 'physics' && classData?.subject?.toLowerCase() !='chemistry' && classData?.subject?.toLowerCase() != 'biology'">
          <img src="assets/img/subject-icons/{{classData?.subject | lowercase }}-icon.svg" class="mstr-subjct-icon" alt="" />
          <span>{{classData?.subject}}</span>
      </ng-container> -->
      <!-- <ng-container *ngIf="showScience && classData?.subject?.toLowerCase() != 'maths'">
          <img src="assets/img/subject-icons/science-icon.svg" class="mstr-subjct-icon" alt="" />
          <span>Science</span>
      </ng-container> -->
      </div>
      <h3 class="UNFAPP-lvmtrcls-title">{{(classData?.title?.length > 43)? (classData?.title | slice:0:35)+'...' : classData?.title}}</h3>
      <h4 class="UNFAPP-lvmtrcls-subtitle">By {{classData?.teacher?.name}}</h4>
      <ul *ngIf="dataType != 'past'" class="UNFAPP-free-lvcls-time-row">
        <li><img src="assets/img/calendar-icon-2.svg" class="lvcls-time-icn" /><span>{{classData?.schedule?.startDate | date: 'd MMM, YYYY'}}</span>
        </li>
        <li><img src="assets/img/time-icon.svg" class="lvcls-time-icn" /><span>{{classData?.schedule?.startTime | date: 'shortTime'}} - {{classData?.schedule?.endTime | date: 'shortTime'}}</span></li>
      </ul>
      </div>
      <div class="UNFAPP-lvmtrcls-actn-area">
          <button *ngIf="!isLive && classData.classStatus && classData.classStatus.toLowerCase() == 'comingup'"   class="_UNFAPP-lvmtrcls-jnbtn UNFAPP-lvmtrcls-cmupbtn" type="button">COMING UP</button>
          <app-custom-button *ngIf="isLive && dataType != 'past'"  type="button" [cta]="{name:'join Now',type:'joinnow', dataType: dataType, data:classData}"></app-custom-button>
          <app-custom-button *ngIf="dataType != 'past' && !isLive && classData.classStatus && classData.classStatus.toLowerCase() == 'register'" [cta]="{name:'register',type:'register', dataType: dataType, data:classData}"></app-custom-button>
          <app-custom-button *ngIf="dataType == 'past'" [cta]="{name:'Watch Now',type:'rewatch', dataType: dataType, data:classData}"></app-custom-button>
          <button type="button" class="UNFAPP-lvmtrcls-dtlbtn" *ngIf="classData?.objectives?.length > 0" (click)="showHideDetails('', index)">DETAILS 
            <i class="fa fa-caret-up" aria-hidden="true"></i>
          </button>
          <div class="UNFAPP-detail-ovrlay-box {{detailsClass}}" *ngIf="detailsIndex === index">
            <div class="UNFAPP-detail-ovrlay-innr">
                <div class="UNFAPP-detail-ovrlay-clsbtn" (click)="showHideDetails('hide', index)">
                  <img src="assets/img/detail-close-icon.svg" />
                </div>
                <h3 class="UNFAPP-detail-ovrlay-hd">Details</h3>
                <div class="UNFAPP-detail-ovrlay-scrl-area">
                    <p *ngFor="let item of classData?.objectives">{{item}}</p>
                </div>
            </div>
          </div>
      </div>
  </div>
    </div>